<mat-dialog-content class="p-0 overflow-y-scroll">

    <div class="flex flex-col" *ngIf="loading">
        <h1 class="text-xl md:text-2xl font-bold mb-4">Checking your Package Options</h1>
        <p>
            <a class="font-bold text-lg">We're busy checking what packages are available at your address:</a> <br>
            {{packageDetails?.FullAddress}}
        </p>
        <div class="flex justify-center pt-5">
            <mat-spinner [diameter]="50"></mat-spinner>
        </div>
    </div>

    <div class="flex flex-col w-full" *ngIf="availablePackages?.length <= 0 && !loading">
        <h1 class="text-xl md:text-2xl font-bold mb-4">No Packages</h1>
        <p>
            <a class="font-medium text-lg">No packages are available for Upgrade</a>
        </p>
    </div>

    <div class="flex flex-col w-full" *ngIf="availablePackages?.length > 0 && !loading">
        <app-swiper-packages [Packages]="availablePackages" [LeadEntityID]="leadEntityID" [DashboardView]="true"></app-swiper-packages>
    </div>

</mat-dialog-content>

<mat-dialog-actions class="static bottom-5 right-5" *ngIf="!loading">
    <div class="flex flex-row w-full justify-end items-end ">
        <button class="mt-2 text-lg font-bold bg-accent w-1/2" mat-flat-button (click)="closeDialog()">
            Close
        </button>
    </div>
</mat-dialog-actions>